import { AEMErrorMessage } from '@com-delta-idp/mnx-skymiles-shared';

export const FullPageErrorMessage: AEMErrorMessage = {
  action: {
    label: 'Delta.com',
    url: '/',
    id: ''
  },
  component: 'full-page',
  errorId: [],
  featureTitle: '',
  errorMessageDescription:
    "We're sorry, but we are currently unable to display the Sky Club page due to a technical issue. Please try again later.",
  errorMessageTitle:
    'Whoops! Looks Like This Page Is Having a Flight Delay. Please Try Again Later.',
  type: 'full-page'
};

export const APIPurchaseErrorMessage: AEMErrorMessage = {
  action: {
    label: '',
    url: '',
    id: ''
  },
  component: 'skyClubError',
  errorId: [],
  featureTitle: '',
  errorMessageDescription:
    'Sorry, we\u2019re currently unable to display this membership options. Please try again later.',
  errorMessageTitle: '',
  type: 'single-error'
};

export const ErrorMessages: AEMErrorMessage[] = [
  FullPageErrorMessage,
  APIPurchaseErrorMessage
];
